module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/target/target.html
// module id = 677
// module chunks = 0